<!-- Section 1: Informacijas pieprasitajs -->
@if (isOrganization) {
  <!-- JP: Company info -->
  <div class="section">
    <div class="client-info-card">
      <div class="client-info-card-header">
        <h4>{{ labels.section('submitter') }}</h4>
        <app-tooltip text="infoRequestRequester" />
      </div>
      <div class="client-info-grid">
        <div class="info-field">
          <p class="info-label">{{ labels.field('submitter','legalEntityName') }}</p>
          <p class="info-value">{{ legalEntity?.name || client?.legalEntityName || client?.fullName || application?.legalEntity?.name || '-' }}</p>
        </div>
        <div class="info-field">
          <p class="info-label">{{ labels.field('submitter','registrationNumber') }}</p>
          <p class="info-value">{{ legalEntity?.registrationNumber || client?.officialDocumentId || application?.legalEntity?.registrationNumber || '-' }}</p>
        </div>
        <div class="info-field">
          <p class="info-label">{{ labels.field('submitter','registrationCountry') }}</p>
          <p class="info-value">{{ legalEntity?.country?.name || client?.country?.name || '-' }}</p>
        </div>
      </div>
      <form [formGroup]="form">
        <div class="editable-fields-grid">
          <div class="field-wrapper">
            <label class="form-label" for="legalAddress">
              {{ labels.field('submitter','legalAddress') }}
            </label>
            <input
              class="form-control"
              id="legalAddress"
              formControlName="legalAddress"
              [maxlength]="maxFieldLength"
              [ngClass]="{ invalid: shouldRenderError('legalAddress') }" />
            @if (getErrorMessage('legalAddress'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          </div>
          <div class="field-wrapper">
            <label class="form-label" for="legalForm">
              {{ labels.field('submitter','legalForm') }}
              <span class="required-field">*</span>
            </label>
            <select
              class="form-control"
              id="legalForm"
              formControlName="legalForm"
              [ngClass]="{ invalid: shouldRenderError('legalForm') }">
              <option [ngValue]="null" disabled>{{ 'pages.service.infoRequest.clientPayer.chooseLegalForm' | translate }}</option>
              @for (option of legalEntityFormOptions; track option.code) {
                <option [value]="option.code">{{ option.name }}</option>
              }
            </select>
            @if (getErrorMessage('legalForm'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          </div>
          <div class="field-wrapper">
            <label class="form-label" for="companyPhone">
              {{ 'pages.service.infoRequest.clientPayer.companyPhone' | translate }}
            </label>
            <input
              class="form-control"
              id="companyPhone"
              formControlName="companyPhone"
              [maxlength]="24"
              [ngClass]="{ invalid: shouldRenderError('companyPhone') }" />
            @if (getErrorMessage('companyPhone'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          </div>
          <div class="field-wrapper">
            <label class="form-label" for="companyEmail">
              {{ 'pages.service.infoRequest.clientPayer.companyEmail' | translate }}
            </label>
            <input
              class="form-control"
              id="companyEmail"
              formControlName="companyEmail"
              [maxlength]="320"
              [ngClass]="{ invalid: shouldRenderError('companyEmail') }" />
            @if (getErrorMessage('companyEmail'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- JP: Kontaktpersona -->
  <div class="section">
    <div class="section-header">
      <h4>{{ labels.field('submitter','contactPerson') }}</h4>
    </div>
    <form [formGroup]="form">
      <div class="editable-fields-grid">
        <div class="field-wrapper">
          <label class="form-label" for="contactPersonName">
            {{ 'pages.service.infoRequest.clientPayer.firstName' | translate }}
            @if (isContactPersonEditable) {
              <span class="required-field">*</span>
            }
          </label>
          @if (isContactPersonEditable) {
            <input
              class="form-control"
              id="contactPersonName"
              formControlName="contactPersonName"
              [maxlength]="maxFieldLength"
              [ngClass]="{ invalid: shouldRenderError('contactPersonName') }" />
            @if (getErrorMessage('contactPersonName'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          } @else {
            <p class="info-value">{{ form.get('contactPersonName')?.value || '-' }}</p>
          }
        </div>
        <div class="field-wrapper">
          <label class="form-label" for="contactPersonSurname">
            {{ 'pages.service.infoRequest.clientPayer.lastName' | translate }}
            @if (isContactPersonEditable) {
              <span class="required-field">*</span>
            }
          </label>
          @if (isContactPersonEditable) {
            <input
              class="form-control"
              id="contactPersonSurname"
              formControlName="contactPersonSurname"
              [maxlength]="maxFieldLength"
              [ngClass]="{ invalid: shouldRenderError('contactPersonSurname') }" />
            @if (getErrorMessage('contactPersonSurname'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          } @else {
            <p class="info-value">{{ form.get('contactPersonSurname')?.value || '-' }}</p>
          }
        </div>
        <div class="field-wrapper">
          <label class="form-label" for="contactPersonEmail">
            {{ 'pages.service.infoRequest.clientPayer.email' | translate }}
          </label>
          @if (isContactPersonEditable) {
            <input
              class="form-control"
              id="contactPersonEmail"
              formControlName="contactPersonEmail"
              [maxlength]="maxFieldLength"
              [ngClass]="{ invalid: shouldRenderError('contactPersonEmail') }" />
            @if (getErrorMessage('contactPersonEmail'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          } @else {
            <p class="info-value">{{ form.get('contactPersonEmail')?.value || '-' }}</p>
          }
        </div>
        <div class="field-wrapper">
          <label class="form-label" for="contactPersonPhone">
            {{ 'pages.service.infoRequest.clientPayer.phone' | translate }}
          </label>
          @if (isContactPersonEditable) {
            <input
              class="form-control"
              id="contactPersonPhone"
              formControlName="contactPersonPhone"
              [maxlength]="maxFieldLength"
              [ngClass]="{ invalid: shouldRenderError('contactPersonPhone') }" />
            @if (getErrorMessage('contactPersonPhone'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          } @else {
            <p class="info-value">{{ form.get('contactPersonPhone')?.value || '-' }}</p>
          }
        </div>
      </div>
    </form>
  </div>
} @else {
  <!-- FP: Personal info -->
  <div class="section">
    <div class="client-info-card">
      <div class="client-info-card-header">
        <h4>{{ labels.section('submitter') }}</h4>
        <app-tooltip text="infoRequestRequester" />
      </div>
      <div class="client-info-grid">
        <div class="info-field">
          <p class="info-label">{{ 'pages.service.infoRequest.clientPayer.firstName' | translate }}</p>
          <p class="info-value">{{ client?.name || application?.client?.name || '-' }}</p>
        </div>
        <div class="info-field">
          <p class="info-label">{{ 'pages.service.infoRequest.clientPayer.lastName' | translate }}</p>
          <p class="info-value">{{ client?.surname || application?.client?.surname || '-' }}</p>
        </div>
        <div class="info-field">
          <p class="info-label">{{ labels.field('submitter','personalCode') }}</p>
          @if (isPersonalCodeEditable) {
            <form [formGroup]="form">
              <input
                class="form-control"
                formControlName="personalCode"
                [maxlength]="50"
                [ngClass]="{ invalid: shouldRenderError('personalCode') }" />
              @if (getErrorMessage('personalCode'); as errorMessage) {
                <div class="error-wrapper">
                  <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                </div>
              }
            </form>
          } @else {
            <p class="info-value">{{ personalCodeDisplayValue }}</p>
          }
        </div>
      </div>
      <form [formGroup]="form">
        <div class="editable-fields-grid">
          <div class="field-wrapper">
            <label class="form-label" for="email">
              {{ labels.field('submitter','email') }}
            </label>
            <input
              class="form-control"
              id="email"
              formControlName="email"
              [maxlength]="maxFieldLength"
              [ngClass]="{ invalid: shouldRenderError('email') }" />
            @if (getErrorMessage('email'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          </div>
          <div class="field-wrapper">
            <label class="form-label" for="phone">
              {{ labels.field('submitter','phone') }}
            </label>
            <input
              class="form-control"
              id="phone"
              formControlName="phone"
              [maxlength]="50"
              [ngClass]="{ invalid: shouldRenderError('phone') }" />
            @if (getErrorMessage('phone'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          </div>
        </div>
      </form>
    </div>
  </div>
}

<form [formGroup]="form">
  <!-- Section 2: Informaciju pieprasu -->
  @if (isOrganization) {
    <!-- JP: Authorization checkbox -->
    <div class="section">
      <div class="checkbox-wrapper">
        <input
          class="form-check-input lna checkbox"
          id="jpAuthorizationChecked"
          type="checkbox"
          formControlName="jpAuthorizationChecked"
          [ngClass]="{ invalid: shouldRenderError('jpAuthorizationChecked') }" />
        <label class="checkbox-label form-label" for="jpAuthorizationChecked">
          {{ labels.field('requester', 'jpAuthorization') }}
        </label>
        <app-tooltip text="infoRequestJpAuthorization" />
      </div>

      @if (form.get('jpAuthorizationChecked')?.value) {
        <div class="conditional-card">
          <div class="conditional-card-header">
            <h5>{{ labels.field('requester', 'authCardTitle') }}</h5>
            <app-tooltip text="infoRequestJpAuthPerson" />
          </div>
          <div class="card-fields">
            <div class="card-fields-row">
              <div class="field-wrapper">
                <label class="form-label" for="jpOtherPersonName">
                  {{ labels.requester('name') }}
                </label>
                <input
                  class="form-control"
                  id="jpOtherPersonName"
                  formControlName="otherPersonName"
                  [maxlength]="100"
                  [ngClass]="{ invalid: shouldRenderError('otherPersonName') }" />
                @if (getErrorMessage('otherPersonName'); as errorMessage) {
                  <div class="error-wrapper">
                    <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                  </div>
                }
              </div>
              <div class="field-wrapper">
                <label class="form-label" for="jpOtherPersonSurname">
                  {{ labels.requester('surname') }}
                </label>
                <input
                  class="form-control"
                  id="jpOtherPersonSurname"
                  formControlName="otherPersonSurname"
                  [maxlength]="100"
                  [ngClass]="{ invalid: shouldRenderError('otherPersonSurname') }" />
                @if (getErrorMessage('otherPersonSurname'); as errorMessage) {
                  <div class="error-wrapper">
                    <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                  </div>
                }
              </div>
            </div>
            <div class="card-fields-row">
              <div class="field-wrapper">
                <label class="form-label" for="jpOtherPersonCode">
                  {{ labels.requester('personalCode') }}
                </label>
                <input
                  class="form-control"
                  id="jpOtherPersonCode"
                  formControlName="otherPersonCode"
                  [maxlength]="100"
                  [ngClass]="{ invalid: shouldRenderError('otherPersonCode') }" />
                @if (getErrorMessage('otherPersonCode'); as errorMessage) {
                  <div class="error-wrapper">
                    <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                  </div>
                }
              </div>
            </div>
            <div class="field-wrapper">
              <label class="form-label" for="jpAuthorizationNumber">
                {{ labels.requester('authorizationNumber') }}
              </label>
              <input
                class="form-control"
                id="jpAuthorizationNumber"
                formControlName="authorizationNumber"
                [maxlength]="255"
                [ngClass]="{ invalid: shouldRenderError('authorizationNumber') }" />
              @if (getErrorMessage('authorizationNumber'); as errorMessage) {
                <div class="error-wrapper">
                  <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                </div>
              }
            </div>
            <div class="field-wrapper">
              <label class="form-label">
                {{ 'pages.service.infoRequest.clientPayer.uploadSignedDocument' | translate }}
              </label>
              @if (application?.id) {
                <app-file-upload
                  #jpAuthorizationUpload
                  [type]="fileTypeAuthorization"
                  [associatedEntityId]="application!.id"
                  [existingFiles]="existingAuthorizationFiles"
                  [isEditMode]="true"
                  [isSubmitting]="isSubmittingFiles"
                  [showDescription]="true"
                  [showBackofficeNote]="false"
                  [showTerm]="false"
                  [maxFiles]="10"
                  [savedFiles]="savedClientPayerFiles['jpAuthorization']"
                  (uploading)="fileUploading.emit($event)"
                  (filesChanged)="onClientPayerFileChanged('jpAuthorization', $event)"
                  (fileDeleted)="markFilesChanged()"
                  (filesAdded)="markFilesChanged()" />
              }
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
  <!-- FP: Informaciju pieprasu -->
  <div class="section">
    <div class="section-header">
      <h4>
        {{ labels.section('requester') }}
        <span class="required-field">*</span>
      </h4>
      <app-tooltip text="infoRequestRelationType" />
    </div>
    <div class="radio-group" [ngClass]="{ invalid: shouldRenderError('requesterRelationType') }">
      <!-- Par sevi -->
      <div class="radio-option">
        <input
          type="radio"
          id="relationType_forSelf"
          formControlName="requesterRelationType"
          value="ForSelf"
          [ngClass]="{ invalid: shouldRenderError('requesterRelationType') }" />
        <label for="relationType_forSelf">{{ 'pages.service.infoRequest.clientPayer.forSelf' | translate }}</label>
      </div>

      <!-- Par citu personu -->
      <div class="radio-option">
        <input
          type="radio"
          id="relationType_forOther"
          formControlName="requesterRelationType"
          value="ForOtherPerson"
          [ngClass]="{ invalid: shouldRenderError('requesterRelationType') }" />
        <label for="relationType_forOther">{{ 'pages.service.infoRequest.clientPayer.forOtherPerson' | translate }}</label>
      </div>

      @if (requesterRelationType === 'ForOtherPerson') {
        <div class="sub-radio-group" [ngClass]="{ invalid: shouldRenderError('requesterForOtherPersonType') }">
          <!-- Pilnvarojums vai rakstveida atluja -->
          <div class="radio-option">
            <input
              type="radio"
              id="otherType_auth"
              formControlName="requesterForOtherPersonType"
              value="AuthorizationOrPermission"
              [ngClass]="{ invalid: shouldRenderError('requesterForOtherPersonType') }" />
            <label for="otherType_auth">{{ 'pages.service.infoRequest.clientPayer.authorizationOrPermission' | translate }}</label>
          </div>

          @if (requesterForOtherPersonType === 'AuthorizationOrPermission') {
            <div class="conditional-card">
              <div class="conditional-card-header">
                <h5>{{ labels.field('requester', 'authCardTitle') }}</h5>
                <app-tooltip text="infoRequestAuthPerson" />
              </div>
              <div class="card-fields">
                <div class="card-fields-row">
                  <div class="field-wrapper">
                    <label class="form-label" for="otherPersonName">
                      {{ labels.requester('name') }}
                    </label>
                    <input
                      class="form-control"
                      id="otherPersonName"
                      formControlName="otherPersonName"
                      [maxlength]="100"
                      [ngClass]="{ invalid: shouldRenderError('otherPersonName') }" />
                    @if (getErrorMessage('otherPersonName'); as errorMessage) {
                      <div class="error-wrapper">
                        <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                      </div>
                    }
                  </div>
                  <div class="field-wrapper">
                    <label class="form-label" for="otherPersonSurname">
                      {{ labels.requester('surname') }}
                    </label>
                    <input
                      class="form-control"
                      id="otherPersonSurname"
                      formControlName="otherPersonSurname"
                      [maxlength]="100"
                      [ngClass]="{ invalid: shouldRenderError('otherPersonSurname') }" />
                    @if (getErrorMessage('otherPersonSurname'); as errorMessage) {
                      <div class="error-wrapper">
                        <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                      </div>
                    }
                  </div>
                </div>
                <div class="card-fields-row">
                  <div class="field-wrapper">
                    <label class="form-label" for="otherPersonCode">
                      {{ labels.requester('personalCode') }}
                    </label>
                    <input
                      class="form-control"
                      id="otherPersonCode"
                      formControlName="otherPersonCode"
                      [maxlength]="maxFieldLength"
                      [ngClass]="{ invalid: shouldRenderError('otherPersonCode') }" />
                    @if (getErrorMessage('otherPersonCode'); as errorMessage) {
                      <div class="error-wrapper">
                        <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                      </div>
                    }
                  </div>
                </div>
                <div class="field-wrapper">
                  <label class="form-label" for="authorizationNumber">
                    {{ labels.requester('authorizationNumber') }}
                  </label>
                  <input
                    class="form-control"
                    id="authorizationNumber"
                    formControlName="authorizationNumber"
                    [maxlength]="maxFieldLength"
                    [ngClass]="{ invalid: shouldRenderError('authorizationNumber') }" />
                  @if (getErrorMessage('authorizationNumber'); as errorMessage) {
                    <div class="error-wrapper">
                      <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                    </div>
                  }
                </div>
                <div class="field-wrapper">
                  <label class="form-label">
                    {{ 'pages.service.infoRequest.clientPayer.uploadSignedDocument' | translate }}
                  </label>
                  @if (application?.id) {
                    <app-file-upload
                      #authorizationUpload
                      [type]="fileTypeAuthorization"
                      [associatedEntityId]="application!.id"
                      [existingFiles]="existingAuthorizationFiles"
                      [isEditMode]="true"
                      [isSubmitting]="isSubmittingFiles"
                      [showDescription]="true"
                      [showBackofficeNote]="false"
                      [showTerm]="false"
                      [maxFiles]="10"
                      [savedFiles]="savedClientPayerFiles['authorization']"
                      (uploading)="fileUploading.emit($event)"
                      (filesChanged)="onClientPayerFileChanged('authorization', $event)"
                      (fileDeleted)="markFilesChanged()"
                      (filesAdded)="markFilesChanged()" />
                  }
                </div>
              </div>
            </div>
          }

          <!-- Mirusais radinieks -->
          <div class="radio-option">
            <input
              type="radio"
              id="otherType_deceased"
              formControlName="requesterForOtherPersonType"
              value="DeceasedRelative"
              [ngClass]="{ invalid: shouldRenderError('requesterForOtherPersonType') }" />
            <label for="otherType_deceased">{{ 'pages.service.infoRequest.clientPayer.deceasedRelative' | translate }}</label>
          </div>

          @if (requesterForOtherPersonType === 'DeceasedRelative') {
            <div class="conditional-card">
              <div class="conditional-card-header">
                <h5>{{ labels.field('requester', 'deceasedCardTitle') }}</h5>
                <app-tooltip text="infoRequestDeceasedPerson" />
              </div>
              <div class="card-fields">
                <div class="field-wrapper">
                  <label class="form-label" for="relationshipType">
                    {{ labels.requester('relationshipType') }}
                  </label>
                  <input
                    class="form-control"
                    id="relationshipType"
                    formControlName="relationshipType"
                    [maxlength]="100"
                    [ngClass]="{ invalid: shouldRenderError('relationshipType') }" />
                  @if (getErrorMessage('relationshipType'); as errorMessage) {
                    <div class="error-wrapper">
                      <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                    </div>
                  }
                </div>
                <div class="card-fields-row">
                  <div class="field-wrapper">
                    <label class="form-label" for="deceasedName">
                      {{ labels.requester('name') }}
                    </label>
                    <input
                      class="form-control"
                      id="deceasedName"
                      formControlName="otherPersonName"
                      [maxlength]="100"
                      [ngClass]="{ invalid: shouldRenderError('otherPersonName') }" />
                    @if (getErrorMessage('otherPersonName'); as errorMessage) {
                      <div class="error-wrapper">
                        <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                      </div>
                    }
                  </div>
                  <div class="field-wrapper">
                    <label class="form-label" for="deceasedSurname">
                      {{ labels.requester('surname') }}
                    </label>
                    <input
                      class="form-control"
                      id="deceasedSurname"
                      formControlName="otherPersonSurname"
                      [maxlength]="100"
                      [ngClass]="{ invalid: shouldRenderError('otherPersonSurname') }" />
                    @if (getErrorMessage('otherPersonSurname'); as errorMessage) {
                      <div class="error-wrapper">
                        <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                      </div>
                    }
                  </div>
                </div>
                <div class="card-fields-row">
                  <div class="field-wrapper">
                    <label class="form-label" for="deceasedCode">
                      {{ labels.requester('personalCode') }}
                    </label>
                    <input
                      class="form-control"
                      id="deceasedCode"
                      formControlName="otherPersonCode"
                      [maxlength]="maxFieldLength"
                      [ngClass]="{ invalid: shouldRenderError('otherPersonCode') }" />
                    @if (getErrorMessage('otherPersonCode'); as errorMessage) {
                      <div class="error-wrapper">
                        <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                      </div>
                    }
                  </div>
                  <div class="field-wrapper">
                    <label class="form-label" for="deathCertificateData">
                      {{ labels.requester('deathCertificateData') }}
                    </label>
                    <input
                      class="form-control"
                      id="deathCertificateData"
                      formControlName="deathCertificateData"
                      [maxlength]="255"
                      [ngClass]="{ invalid: shouldRenderError('deathCertificateData') }" />
                  </div>
                </div>
                <div class="field-wrapper">
                  <label class="form-label">
                    {{ 'pages.service.infoRequest.clientPayer.uploadDeathCertificate' | translate }}
                  </label>
                  @if (application?.id) {
                    <app-file-upload
                      #deathCertificateUpload
                      [type]="fileTypeDeathCertificate"
                      [associatedEntityId]="application!.id"
                      [existingFiles]="existingDeathCertificateFiles"
                      [isEditMode]="true"
                      [isSubmitting]="isSubmittingFiles"
                      [showDescription]="true"
                      [showBackofficeNote]="false"
                      [showTerm]="false"
                      [maxFiles]="10"
                      [savedFiles]="savedClientPayerFiles['deathCertificate']"
                      (uploading)="fileUploading.emit($event)"
                      (filesChanged)="onClientPayerFileChanged('deathCertificate', $event)"
                      (fileDeleted)="markFilesChanged()"
                      (filesAdded)="markFilesChanged()" />
                  }
                </div>
              </div>
            </div>
          }

          <!-- Cits -->
          <div class="radio-option">
            <input
              type="radio"
              id="otherType_other"
              formControlName="requesterForOtherPersonType"
              value="Other"
              [ngClass]="{ invalid: shouldRenderError('requesterForOtherPersonType') }" />
            <label for="otherType_other">{{ 'pages.service.infoRequest.clientPayer.otherCase' | translate }}</label>
            <app-tooltip text="infoRequestOtherCase" />
          </div>

          @if (requesterForOtherPersonType === 'Other') {
            <div class="conditional-card">
              <div class="conditional-card-header">
                <h5>{{ 'pages.service.infoRequest.clientPayer.additionalInfo' | translate }}</h5>
                <app-tooltip text="infoRequestAdditionalInfo" />
              </div>
              <div class="card-fields">
                <div class="field-wrapper">
                  <textarea
                    class="form-control"
                    id="otherPersonDescription"
                    formControlName="otherPersonDescription"
                    [maxlength]="255"
                    [ngClass]="{ invalid: shouldRenderError('otherPersonDescription') }"></textarea>
                  @if (getErrorMessage('otherPersonDescription'); as errorMessage) {
                    <div class="error-wrapper">
                      <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }

      <!-- Cits gadijums -->
      <div class="radio-option">
        <input
          type="radio"
          id="relationType_otherCase"
          formControlName="requesterRelationType"
          value="OtherCase"
          [ngClass]="{ invalid: shouldRenderError('requesterRelationType') }" />
        <label for="relationType_otherCase">{{ 'pages.service.infoRequest.clientPayer.otherCaseGeneral' | translate }}</label>
      </div>

      @if (requesterRelationType === 'OtherCase') {
        <div class="conditional-card">
          <div class="conditional-card-header">
            <h5>{{ 'pages.service.infoRequest.clientPayer.additionalInfo' | translate }}</h5>
            <app-tooltip text="infoRequestOtherCaseAdditionalInfo" />
          </div>
          <div class="card-fields">
            <div class="field-wrapper">
              <textarea
                class="form-control"
                id="otherCaseDescription"
                formControlName="otherPersonDescription"
                [maxlength]="1000"
                [ngClass]="{ invalid: shouldRenderError('otherPersonDescription') }"></textarea>
              @if (getErrorMessage('otherPersonDescription'); as errorMessage) {
                <div class="error-wrapper">
                  <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>

    @if (shouldRenderError('requesterRelationType')) {
      <div class="error-wrapper">
        <small class="error-message" aria-live="polite">{{ 'components.form.errorRequired' | translate }}</small>
      </div>
    }
  </div>

  } <!-- end Section 2 @if/@else -->

  <!-- Shared discount card template (Disability, LowIncome, PoliticallyRepressed) -->
  <ng-template #discountSharedCard>
    <div class="conditional-card">
      <div class="card-fields">
        <div class="card-fields-row">
          <div class="field-wrapper">
            <label class="form-label" for="discountName">
              {{ labels.discount('name') }}
            </label>
            <input
              class="form-control"
              id="discountName"
              formControlName="discountName"
              [maxlength]="100"
              [ngClass]="{ invalid: shouldRenderError('discountName') }" />
            @if (getErrorMessage('discountName'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          </div>
          <div class="field-wrapper">
            <label class="form-label" for="discountSurname">
              {{ labels.discount('surname') }}
            </label>
            <input
              class="form-control"
              id="discountSurname"
              formControlName="discountSurname"
              [maxlength]="100"
              [ngClass]="{ invalid: shouldRenderError('discountSurname') }" />
            @if (getErrorMessage('discountSurname'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          </div>
        </div>
        <div class="field-wrapper">
          <label class="form-label" for="discountDocumentNumber">
            {{ discountGroupType === 'LowIncomePerson'
                  ? labels.discount('documentNumber')
                  : labels.field('discount', 'certificateNumber') }}
          </label>
          <input
            class="form-control"
            id="discountDocumentNumber"
            formControlName="discountDocumentNumber"
            [maxlength]="100"
            [ngClass]="{ invalid: shouldRenderError('discountDocumentNumber') }" />
          @if (getErrorMessage('discountDocumentNumber'); as errorMessage) {
            <div class="error-wrapper">
              <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
            </div>
          }
        </div>
        @if (discountGroupType === 'FirstOrSecondGroupDisability' || discountGroupType === 'LowIncomePerson') {
          <div class="field-wrapper">
            <label class="form-label" for="discountDocumentExpiry">
              {{ labels.discount('documentExpiry') }}
            </label>
            <app-date-picker
              [date]="form.get('discountDocumentExpiry')?.value || ''"
              [invalid]="shouldRenderError('discountDocumentExpiry')"
              (dateSelected)="onDiscountDateSelected($event)"
              (blured)="markAsTouched('discountDocumentExpiry')" />
            @if (getErrorMessage('discountDocumentExpiry'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          </div>
        }
        @if (discountGroupType === 'LowIncomePerson') {
          <div class="field-wrapper">
            <label class="form-label" for="discountDocumentIssuer">
              {{ labels.discount('documentIssuer') }}
            </label>
            <input
              class="form-control"
              id="discountDocumentIssuer"
              formControlName="discountDocumentIssuer"
              [maxlength]="100"
              [ngClass]="{ invalid: shouldRenderError('discountDocumentIssuer') }" />
            @if (getErrorMessage('discountDocumentIssuer'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          </div>
        }
        <div class="file-upload-wrapper">
          @if (application?.id) {
            <app-file-upload
              #discountGroupUpload
              [type]="fileTypeDiscount"
              [associatedEntityId]="application!.id"
              [existingFiles]="existingDiscountFiles"
              [isEditMode]="true"
              [isSubmitting]="isSubmittingFiles"
              [showDescription]="true"
              [showBackofficeNote]="false"
              [showTerm]="false"
              [maxFiles]="10"
              [savedFiles]="savedClientPayerFiles['discountGroup']"
              (uploading)="fileUploading.emit($event)"
              (filesChanged)="onClientPayerFileChanged('discountGroup', $event)"
              (fileDeleted)="markFilesChanged()"
              (filesAdded)="markFilesChanged()" />
          }
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Section 3: Discount group (FP, or JP with authorization) -->
  @if (showDiscountSection) {
  <div class="section">
    <div class="label-wrapper">
      <h4>
        {{ labels.section('discount') }}
      </h4>
      <app-tooltip text="infoRequestDiscountGroup" />
    </div>
    <div class="radio-group" [ngClass]="{ invalid: shouldRenderError('discountGroupType') }">
      <div class="radio-option">
        <input
          type="radio"
          id="discount_none"
          [checked]="discountGroupType === 'None'"
          (click)="selectDiscountGroup('None')"
          name="discountGroupRadio" />
        <label for="discount_none">{{ 'pages.service.infoRequest.clientPayer.discountNone' | translate }}</label>
      </div>

      <div class="radio-option">
        <input
          type="radio"
          id="discount_disability"
          [checked]="discountGroupType === 'FirstOrSecondGroupDisability'"
          (click)="selectDiscountGroup('FirstOrSecondGroupDisability')"
          name="discountGroupRadio" />
        <label for="discount_disability">{{ 'pages.service.infoRequest.clientPayer.discountDisability' | translate }}</label>
      </div>
      @if (discountGroupType === 'FirstOrSecondGroupDisability') {
        <ng-container *ngTemplateOutlet="discountSharedCard" />
      }

      <div class="radio-option">
        <input
          type="radio"
          id="discount_lowIncome"
          [checked]="discountGroupType === 'LowIncomePerson'"
          (click)="selectDiscountGroup('LowIncomePerson')"
          name="discountGroupRadio" />
        <label for="discount_lowIncome">{{ 'pages.service.infoRequest.clientPayer.discountLowIncome' | translate }}</label>
      </div>
      @if (discountGroupType === 'LowIncomePerson') {
        <ng-container *ngTemplateOutlet="discountSharedCard" />
      }

      <div class="radio-option">
        <input
          type="radio"
          id="discount_repressed"
          [checked]="discountGroupType === 'PoliticallyRepressed'"
          (click)="selectDiscountGroup('PoliticallyRepressed')"
          name="discountGroupRadio" />
        <label for="discount_repressed">{{ 'pages.service.infoRequest.clientPayer.discountRepressed' | translate }}</label>
      </div>
      @if (discountGroupType === 'PoliticallyRepressed') {
        <ng-container *ngTemplateOutlet="discountSharedCard" />
      }

      <div class="radio-option">
        <input
          type="radio"
          id="discount_childProtection"
          [checked]="discountGroupType === 'ChildProtection'"
          (click)="selectDiscountGroup('ChildProtection')"
          name="discountGroupRadio" />
        <label for="discount_childProtection">{{ 'pages.service.infoRequest.clientPayer.discountChildProtection' | translate }}</label>
      </div>
      @if (discountGroupType === 'ChildProtection') {
        <div class="conditional-card">
          <div class="card-fields">
            <div class="field-wrapper">
              <label class="form-label" for="discountReason">
                {{ labels.discount('reason') }}
              </label>
              <input
                class="form-control"
                id="discountReason"
                formControlName="discountReason"
                [maxlength]="255"
                [ngClass]="{ invalid: shouldRenderError('discountReason') }" />
              @if (getErrorMessage('discountReason'); as errorMessage) {
                <div class="error-wrapper">
                  <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                </div>
              }
            </div>
          </div>
        </div>
      }

      <div class="radio-option">
        <input
          type="radio"
          id="discount_otherCase"
          [checked]="discountGroupType === 'OtherCase'"
          (click)="selectDiscountGroup('OtherCase')"
          name="discountGroupRadio" />
        <label for="discount_otherCase">{{ 'pages.service.infoRequest.clientPayer.discountOther' | translate }}</label>
      </div>
      @if (discountGroupType === 'OtherCase') {
        <div class="conditional-card">
          <div class="card-fields">
            <div class="field-wrapper">
              <label class="form-label" for="discountReasonOther">
                {{ labels.discount('reason') }}
                <span class="required-field">*</span>
              </label>
              <input
                class="form-control"
                id="discountReasonOther"
                formControlName="discountReason"
                [maxlength]="255"
                [ngClass]="{ invalid: shouldRenderError('discountReason') }" />
              @if (getErrorMessage('discountReason'); as errorMessage) {
                <div class="error-wrapper">
                  <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
    @if (shouldRenderError('discountGroupType')) {
      <div class="error-wrapper">
        <small class="error-message" aria-live="polite">{{ 'components.form.errorRequired' | translate }}</small>
      </div>
    }
  </div>
  }

  <!-- Section 4: Apmaksu veiks (Payment) -->
  <div class="section">
    <div class="section-header">
      <h4>
        {{ labels.section('payer') }}
        <span class="required-field">*</span>
      </h4>
      <app-tooltip text="infoRequestPayer" />
    </div>
    <div class="radio-group radio-group-inline" [ngClass]="{ invalid: shouldRenderError('payerType') }">
      <div class="radio-option">
        <input
          type="radio"
          id="payer_requester"
          formControlName="payerType"
          value="Requester"
          [ngClass]="{ invalid: shouldRenderError('payerType') }" />
        <label for="payer_requester">{{ 'pages.service.infoRequest.clientPayer.payerRequester' | translate }}</label>
      </div>
      <div class="radio-option">
        <input
          type="radio"
          id="payer_otherPerson"
          formControlName="payerType"
          value="OtherPhysicalPerson"
          [ngClass]="{ invalid: shouldRenderError('payerType') }" />
        <label for="payer_otherPerson">{{ 'pages.service.infoRequest.clientPayer.payerOtherPerson' | translate }}</label>
      </div>
      <div class="radio-option">
        <input
          type="radio"
          id="payer_legalEntity"
          formControlName="payerType"
          value="OtherLegalEntity"
          [ngClass]="{ invalid: shouldRenderError('payerType') }" />
        <label for="payer_legalEntity">{{ 'pages.service.infoRequest.clientPayer.payerLegalEntity' | translate }}</label>
      </div>
      <div class="radio-option">
        <input
          type="radio"
          id="payer_freeOfCharge"
          formControlName="payerType"
          value="FreeOfCharge"
          [ngClass]="{ invalid: shouldRenderError('payerType') }" />
        <label for="payer_freeOfCharge">{{ 'pages.service.infoRequest.clientPayer.payerFreeOfCharge' | translate }}</label>
      </div>
    </div>

      @if (payerType === 'Requester' && !isOrganization) {
        <div class="conditional-card">
          <div class="card-fields">
            <div class="card-fields-row">
              <div class="info-field">
                <p class="info-label">{{ 'pages.service.infoRequest.clientPayer.firstName' | translate }}</p>
                <p class="info-value">{{ client?.name || application?.client?.name || '-' }}</p>
              </div>
              <div class="info-field">
                <p class="info-label">{{ 'pages.service.infoRequest.clientPayer.lastName' | translate }}</p>
                <p class="info-value">{{ client?.surname || application?.client?.surname || '-' }}</p>
              </div>
            </div>
            <div class="info-field">
              <p class="info-label">{{ 'pages.service.infoRequest.clientPayer.personalCode' | translate }}</p>
              <p class="info-value">{{ client?.officialDocumentId || client?.nationalDigitalId || application?.client?.personalCode || '-' }}</p>
            </div>
          </div>
        </div>
      }

      @if (payerType === 'Requester' && isOrganization) {
        <div class="conditional-card">
          <div class="card-fields">
            <div class="card-fields-row">
              <div class="info-field">
                <p class="info-label">{{ 'pages.service.infoRequest.clientPayer.registrationCountry' | translate }}</p>
                <p class="info-value">{{ legalEntity?.country?.name || client?.country?.name || '-' }}</p>
              </div>
              <div class="info-field">
                <p class="info-label">{{ 'pages.service.infoRequest.clientPayer.registrationNumber' | translate }}</p>
                <p class="info-value">{{ legalEntity?.registrationNumber || client?.officialDocumentId || application?.legalEntity?.registrationNumber || '-' }}</p>
              </div>
            </div>
            <div class="card-fields-row">
              <div class="info-field">
                <p class="info-label">{{ 'pages.service.infoRequest.clientPayer.companyName' | translate }}</p>
                <p class="info-value">{{ legalEntity?.name || client?.legalEntityName || application?.legalEntity?.name || '-' }}</p>
              </div>
              <div class="info-field">
                <p class="info-label">{{ 'pages.service.infoRequest.clientPayer.legalForm' | translate }}</p>
                <p class="info-value">{{ legalFormName || '-' }}</p>
              </div>
            </div>
            <div class="field-wrapper">
              <label class="form-label" for="payerVatNumberRequester">
                {{ labels.payer('vatNumber') }}
              </label>
              <input
                class="form-control"
                id="payerVatNumberRequester"
                formControlName="payerVatNumber"
                [maxlength]="50"
                [ngClass]="{ invalid: shouldRenderError('payerVatNumber') }" />
            </div>
          </div>
        </div>
      }

      @if (payerType === 'OtherPhysicalPerson') {
        <div class="conditional-card">
          <div class="card-fields">
            <div class="card-fields-row">
              <div class="field-wrapper">
                <label class="form-label" for="payerName">
                  {{ labels.payer('name') }}
                </label>
                <input
                  class="form-control"
                  id="payerName"
                  formControlName="payerName"
                  [maxlength]="100"
                  [ngClass]="{ invalid: shouldRenderError('payerName') }" />
                @if (getErrorMessage('payerName'); as errorMessage) {
                  <div class="error-wrapper">
                    <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                  </div>
                }
              </div>
              <div class="field-wrapper">
                <label class="form-label" for="payerSurname">
                  {{ labels.payer('surname') }}
                </label>
                <input
                  class="form-control"
                  id="payerSurname"
                  formControlName="payerSurname"
                  [maxlength]="100"
                  [ngClass]="{ invalid: shouldRenderError('payerSurname') }" />
                @if (getErrorMessage('payerSurname'); as errorMessage) {
                  <div class="error-wrapper">
                    <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                  </div>
                }
              </div>
            </div>
            <div class="field-wrapper">
              <label class="form-label" for="payerPersonalCode">
                {{ 'pages.service.infoRequest.clientPayer.personalCode' | translate }}
              </label>
              <input
                class="form-control"
                id="payerPersonalCode"
                formControlName="payerPersonalCode"
                [maxlength]="12"
                [ngClass]="{ invalid: shouldRenderError('payerPersonalCode') }" />
              @if (getErrorMessage('payerPersonalCode'); as errorMessage) {
                <div class="error-wrapper">
                  <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                </div>
              }
            </div>
          </div>
        </div>
      }

      @if (payerType === 'OtherLegalEntity') {
        <div class="conditional-card">
          <div class="card-fields">
            <div class="field-wrapper">
              <label class="form-label" for="payerCountry">
                {{ labels.payer('country') }}
              </label>
              <select
                class="form-control"
                id="payerCountry"
                formControlName="payerCountry"
                [ngClass]="{ invalid: shouldRenderError('payerCountry') }">
                <option [ngValue]="''" disabled>{{ 'pages.service.infoRequest.clientPayer.chooseCountry' | translate }}</option>
                @for (country of countries; track country.id) {
                  <option [value]="country.name">{{ country.name }}</option>
                }
              </select>
              @if (getErrorMessage('payerCountry'); as errorMessage) {
                <div class="error-wrapper">
                  <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                </div>
              }
            </div>
            <div class="field-wrapper">
              <label class="form-label" for="payerRegistrationNumber">
                {{ 'pages.service.infoRequest.clientPayer.registrationNumber' | translate }}
              </label>
              <input
                class="form-control"
                id="payerRegistrationNumber"
                formControlName="payerRegistrationNumber"
                [maxlength]="50"
                [ngClass]="{ invalid: shouldRenderError('payerRegistrationNumber') }" />
              @if (getErrorMessage('payerRegistrationNumber'); as errorMessage) {
                <div class="error-wrapper">
                  <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                </div>
              }
            </div>
            <div class="field-wrapper">
              <label class="form-label" for="payerVatNumber">
                {{ labels.payer('vatNumber') }}
              </label>
              <input
                class="form-control"
                id="payerVatNumber"
                formControlName="payerVatNumber"
                [maxlength]="50"
                [ngClass]="{ invalid: shouldRenderError('payerVatNumber') }" />
            </div>
            <div class="field-wrapper">
              <label class="form-label" for="payerLegalEntityName">
                {{ labels.payer('companyName') }}
              </label>
              <input
                class="form-control"
                id="payerLegalEntityName"
                formControlName="payerLegalEntityName"
                [maxlength]="255"
                [ngClass]="{ invalid: shouldRenderError('payerLegalEntityName') }" />
              @if (getErrorMessage('payerLegalEntityName'); as errorMessage) {
                <div class="error-wrapper">
                  <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                </div>
              }
            </div>
            <div class="field-wrapper">
              <label class="form-label" for="payerLegalForm">
                {{ labels.payer('legalForm') }}
              </label>
              <select
                class="form-control"
                id="payerLegalForm"
                formControlName="payerLegalForm"
                [ngClass]="{ invalid: shouldRenderError('payerLegalForm') }">
                <option [ngValue]="''" disabled>{{ 'pages.service.infoRequest.clientPayer.chooseLegalForm' | translate }}</option>
                @for (option of legalEntityFormOptions; track option.code) {
                  <option [value]="option.code">{{ option.name }}</option>
                }
              </select>
              @if (getErrorMessage('payerLegalForm'); as errorMessage) {
                <div class="error-wrapper">
                  <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                </div>
              }
            </div>
          </div>
        </div>
      }

      @if (payerType === 'FreeOfCharge') {
        <div class="conditional-card">
          <div class="field-wrapper">
            <label class="form-label" for="payerFreeOfChargeReason">
              {{ labels.field('payer', 'freeOfChargeReason') }}
            </label>
            <input
              class="form-control"
              id="payerFreeOfChargeReason"
              formControlName="payerFreeOfChargeReason"
              [maxlength]="255"
              [ngClass]="{ invalid: shouldRenderError('payerFreeOfChargeReason') }" />
            @if (getErrorMessage('payerFreeOfChargeReason'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          </div>
        </div>
      }

    @if (shouldRenderError('payerType')) {
      <div class="error-wrapper">
        <small class="error-message" aria-live="polite">{{ 'components.form.errorRequired' | translate }}</small>
      </div>
    }

    <!-- Rekina sanemsanas veids (Invoice delivery) -->
    <div class="section-header" style="margin-top: 24px">
      <h4>
        {{ labels.section('invoiceDelivery') }}
        <span class="required-field">*</span>
      </h4>
      <app-tooltip text="infoRequestInvoiceDelivery" />
    </div>
    <div class="radio-group radio-group-inline" [ngClass]="{ invalid: shouldRenderError('invoiceDeliveryMethod') }">
      <div class="radio-option">
        <input
          type="radio"
          id="invoice_portal"
          formControlName="invoiceDeliveryMethod"
          value="Portal"
          [ngClass]="{ invalid: shouldRenderError('invoiceDeliveryMethod') }" />
        <label for="invoice_portal">{{ 'pages.service.infoRequest.clientPayer.portal' | translate }}</label>
      </div>
      <div class="radio-option">
        <input
          type="radio"
          id="invoice_email"
          formControlName="invoiceDeliveryMethod"
          value="Email"
          [ngClass]="{ invalid: shouldRenderError('invoiceDeliveryMethod') }" />
        <label for="invoice_email">{{ 'pages.service.infoRequest.clientPayer.emailMethod' | translate }}</label>
      </div>
      <div class="radio-option">
        <input
          type="radio"
          id="invoice_eaddress"
          formControlName="invoiceDeliveryMethod"
          value="EAddress"
          [ngClass]="{ invalid: shouldRenderError('invoiceDeliveryMethod') }" />
        <label for="invoice_eaddress">{{ labels.field('invoiceDelivery', 'detailEAddress') }}</label>
      </div>
      <div class="radio-option">
        <input
          type="radio"
          id="invoice_postal"
          formControlName="invoiceDeliveryMethod"
          value="PostalMail"
          [ngClass]="{ invalid: shouldRenderError('invoiceDeliveryMethod') }" />
        <label for="invoice_postal">{{ 'pages.service.infoRequest.clientPayer.postalMail' | translate }}</label>
      </div>
      <div class="radio-option">
        <input
          type="radio"
          id="invoice_archive"
          formControlName="invoiceDeliveryMethod"
          value="Archive"
          [ngClass]="{ invalid: shouldRenderError('invoiceDeliveryMethod') }" />
        <label for="invoice_archive">{{ 'pages.service.infoRequest.clientPayer.invoiceArchive' | translate }}</label>
      </div>
      <div class="radio-option">
        <input
          type="radio"
          id="invoice_freeOfCharge"
          formControlName="invoiceDeliveryMethod"
          value="FreeOfCharge"
          [disabled]="payerType !== 'FreeOfCharge'"
          [ngClass]="{ invalid: shouldRenderError('invoiceDeliveryMethod') }" />
        <label for="invoice_freeOfCharge">{{ 'pages.service.infoRequest.clientPayer.invoiceFreeOfCharge' | translate }}</label>
      </div>
    </div>

    @if (invoiceDeliveryMethod === 'Email') {
      <div class="conditional-card">
        <div class="field-wrapper">
          <label class="form-label" for="invoiceEmail">
            {{ 'pages.service.infoRequest.clientPayer.email' | translate }}
          </label>
          <input
            class="form-control"
            id="invoiceEmail"
            formControlName="invoiceEmail"
            [maxlength]="320"
            [ngClass]="{ invalid: shouldRenderError('invoiceEmail') }" />
          @if (getErrorMessage('invoiceEmail'); as errorMessage) {
            <div class="error-wrapper">
              <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
            </div>
          }
        </div>
      </div>
    }

    @if (invoiceDeliveryMethod === 'EAddress') {
      <div class="conditional-card">
        <div class="field-wrapper">
          <label class="form-label" for="invoiceEAddress">
            {{ labels.field('invoiceDelivery', 'detailEAddress') }}
          </label>
          <input
            class="form-control"
            id="invoiceEAddress"
            formControlName="invoiceEAddress"
            [ngClass]="{ invalid: shouldRenderError('invoiceEAddress') }" />
          @if (getErrorMessage('invoiceEAddress'); as errorMessage) {
            <div class="error-wrapper">
              <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
            </div>
          }
        </div>
      </div>
    }

    @if (invoiceDeliveryMethod === 'PostalMail') {
      <div class="conditional-card">
        <div class="field-wrapper">
          <label class="form-label" for="invoiceAddress">
            {{ labels.field('invoiceDelivery', 'detailAddress') }}
          </label>
          <input
            class="form-control"
            id="invoiceAddress"
            formControlName="invoiceAddress"
            [maxlength]="255"
            [ngClass]="{ invalid: shouldRenderError('invoiceAddress') }" />
          @if (getErrorMessage('invoiceAddress'); as errorMessage) {
            <div class="error-wrapper">
              <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
            </div>
          }
        </div>
      </div>
    }

    @if (invoiceDeliveryMethod === 'Archive') {
      <div class="conditional-card">
        <div class="field-wrapper">
          <label class="form-label" for="invoiceDeliveryStructuralUnitId">
            {{ labels.field('invoiceDelivery', 'structuralUnit') }}
            <span class="required-field">*</span>
          </label>
          <select
            class="form-control"
            id="invoiceDeliveryStructuralUnitId"
            formControlName="invoiceDeliveryStructuralUnitId"
            [ngClass]="{ invalid: shouldRenderError('invoiceDeliveryStructuralUnitId') }">
            <option value="" disabled>{{ 'pages.service.infoRequest.clientPayer.selectStructuralUnit' | translate }}</option>
            @for (unit of structuralUnits; track unit.id) {
              <option [value]="unit.id">{{ unit.name }}</option>
            }
          </select>
          @if (shouldRenderError('invoiceDeliveryStructuralUnitId')) {
            <div class="error-wrapper">
              <small class="error-message" aria-live="polite">{{ 'components.form.errorRequired' | translate }}</small>
            </div>
          }
        </div>
      </div>
    }

    @if (shouldRenderError('invoiceDeliveryMethod')) {
      <div class="error-wrapper">
        <small class="error-message" aria-live="polite">{{ 'components.form.errorRequired' | translate }}</small>
      </div>
    }
  </div>

  <!-- Section 5: Informacijas merki - Purpose (FP only) -->
  @if (!isOrganization) {
  <div class="section">
    <div class="label-wrapper">
      <h4>
        {{ labels.section('purpose') }}
        <span class="required-field">*</span>
      </h4>
      <app-tooltip text="infoRequestPurpose" />
    </div>
    <div class="radio-group" [ngClass]="{ invalid: shouldRenderError('purpose') }">
      <div class="radio-option">
        <input
          type="radio"
          id="purpose_private"
          formControlName="purpose"
          value="PrivateUse"
          [ngClass]="{ invalid: shouldRenderError('purpose') }" />
        <label for="purpose_private">{{ 'pages.service.infoRequest.clientPayer.purposePrivate' | translate }}</label>
      </div>
      <div class="radio-option">
        <input
          type="radio"
          id="purpose_institution"
          formControlName="purpose"
          value="SubmissionToInstitution"
          [ngClass]="{ invalid: shouldRenderError('purpose') }" />
        <label for="purpose_institution">{{ 'pages.service.infoRequest.clientPayer.purposeInstitution' | translate }}</label>
      </div>

      @if (purpose === 'SubmissionToInstitution') {
        <div class="conditional-card">
          <div class="card-fields">
            <div class="field-wrapper">
              <label class="form-label" for="purposeInstitutionName">
                {{ labels.field('purpose','institutionName') }}
              </label>
              <input
                class="form-control"
                id="purposeInstitutionName"
                formControlName="purposeInstitutionName"
                [maxlength]="maxFieldLength"
                [ngClass]="{ invalid: shouldRenderError('purposeInstitutionName') }" />
              @if (getErrorMessage('purposeInstitutionName'); as errorMessage) {
                <div class="error-wrapper">
                  <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
                </div>
              }
            </div>
            @if (showVsaaCheckbox) {
              <div class="checkbox-wrapper">
                <input
                  class="form-check-input lna checkbox"
                  id="vsaaFlag"
                  type="checkbox"
                  formControlName="vsaaFlag"
                  [ngClass]="{ invalid: shouldRenderError('vsaaFlag') }" />
                <label class="checkbox-label" for="vsaaFlag">
                  {{ labels.field('purpose','vsaa') }}
                </label>
              </div>
            }
          </div>
        </div>
      }

      <div class="radio-option">
        <input
          type="radio"
          id="purpose_foreign"
          formControlName="purpose"
          value="SubmissionToForeignInstitution"
          [ngClass]="{ invalid: shouldRenderError('purpose') }" />
        <label for="purpose_foreign">{{ 'pages.service.infoRequest.clientPayer.purposeForeign' | translate }}</label>
      </div>

      @if (purpose === 'SubmissionToForeignInstitution') {
        <div class="conditional-card">
          <div class="field-wrapper">
            <label class="form-label" for="purposeForeignInstitution">
              {{ labels.field('purpose','institutionName') }}
            </label>
            <input
              class="form-control"
              id="purposeForeignInstitution"
              formControlName="purposeInstitutionName"
              [maxlength]="maxFieldLength"
              [ngClass]="{ invalid: shouldRenderError('purposeInstitutionName') }" />
            @if (getErrorMessage('purposeInstitutionName'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          </div>
        </div>
      }
    </div>

    @if (shouldRenderError('purpose')) {
      <div class="error-wrapper">
        <small class="error-message" aria-live="polite">{{ 'components.form.errorRequired' | translate }}</small>
      </div>
    }
  </div>
  }

  <!-- Section 6: Pakalpojuma izpildes termins (Service deadline) -->
  @if (!inlineEditMode) {
  <div class="section">
    <div class="section-header">
      <h4>
        {{ 'pages.service.infoRequest.clientPayer.deadlineTitle' | translate }}
        <span class="required-field">*</span>
      </h4>
      <app-tooltip text="infoRequestDeadline" />
    </div>
    <div class="radio-group" [ngClass]="{ invalid: shouldRenderError('serviceDeadline') }">
      <div class="radio-option">
        <input
          type="radio"
          id="deadline_30"
          formControlName="serviceDeadline"
          value="Days30"
          [ngClass]="{ invalid: shouldRenderError('serviceDeadline') }" />
        <label for="deadline_30">{{ 'pages.service.infoRequest.clientPayer.days30' | translate }}</label>
      </div>
      <div class="radio-option">
        <input
          type="radio"
          id="deadline_15"
          formControlName="serviceDeadline"
          value="Days15"
          [ngClass]="{ invalid: shouldRenderError('serviceDeadline') }" />
        <label for="deadline_15">
          {{ 'pages.service.infoRequest.clientPayer.days15' | translate }}
          <span class="increased-fee">{{ 'pages.service.infoRequest.clientPayer.increasedFee' | translate }}</span>
        </label>
      </div>
      <div class="radio-option">
        <input
          type="radio"
          id="deadline_10"
          formControlName="serviceDeadline"
          value="Days10"
          [ngClass]="{ invalid: shouldRenderError('serviceDeadline') }" />
        <label for="deadline_10">
          {{ 'pages.service.infoRequest.clientPayer.days10' | translate }}
          <span class="increased-fee">{{ 'pages.service.infoRequest.clientPayer.increasedFee' | translate }}</span>
        </label>
      </div>
      <div class="radio-option">
        <input
          type="radio"
          id="deadline_other"
          formControlName="serviceDeadline"
          value="Other"
          [ngClass]="{ invalid: shouldRenderError('serviceDeadline') }" />
        <label for="deadline_other">{{ 'pages.service.infoRequest.clientPayer.deadlineOther' | translate }}</label>
      </div>
    </div>

    @if (shouldRenderError('serviceDeadline')) {
      <div class="error-wrapper">
        <small class="error-message" aria-live="polite">{{ 'components.form.errorRequired' | translate }}</small>
      </div>
    }

    @if (serviceDeadline === 'Other') {
      <div class="field-wrapper">
        <label class="form-label" for="serviceDeadlineDate">
          {{ 'pages.service.infoRequest.clientPayer.serviceDeadlineDate' | translate }}
          <span class="required-field">*</span>
        </label>
        <app-date-picker
          [date]="form.get('serviceDeadlineDate')?.value || ''"
          [invalid]="shouldRenderError('serviceDeadlineDate')"
          [dateRangeMode]="dateRangeMode.FutureAndToday"
          (dateSelected)="onServiceDeadlineDateSelected($event)"
          (blured)="markAsTouched('serviceDeadlineDate')" />
        @if (shouldRenderError('serviceDeadlineDate')) {
          <div class="error-wrapper">
            <small class="error-message" aria-live="polite">{{ 'components.form.errorRequired' | translate }}</small>
          </div>
        }
      </div>
    }
  </div>
  }

  <!-- Section 7: Sanemsanas veids (Response delivery) -->
  <div class="section">
    <div class="section-header">
      <h4>
        {{ labels.section('responseDelivery') }}
        <span class="required-field">*</span>
      </h4>
      <app-tooltip text="infoRequestResponseDelivery" />
    </div>
    <div class="radio-group" [ngClass]="{ invalid: shouldRenderError('responseDeliveryMethod') }">
      <div class="radio-option">
        <input
          type="radio"
          id="response_portal"
          formControlName="responseDeliveryMethod"
          value="Portal"
          [ngClass]="{ invalid: shouldRenderError('responseDeliveryMethod') }" />
        <label for="response_portal">{{ 'pages.service.infoRequest.clientPayer.portal' | translate }}</label>
      </div>
      <div class="radio-option">
        <input
          type="radio"
          id="response_email"
          formControlName="responseDeliveryMethod"
          value="Email"
          [ngClass]="{ invalid: shouldRenderError('responseDeliveryMethod') }" />
        <label for="response_email">{{ 'pages.service.infoRequest.clientPayer.emailMethod' | translate }}</label>
      </div>

      @if (responseDeliveryMethod === 'Email') {
        <div class="conditional-card">
          <div class="field-wrapper">
            <label class="form-label" for="responseEmail">
              {{ 'pages.service.infoRequest.clientPayer.email' | translate }}
            </label>
            <input
              class="form-control"
              id="responseEmail"
              formControlName="responseEmail"
              [maxlength]="320"
              [ngClass]="{ invalid: shouldRenderError('responseEmail') }" />
            @if (getErrorMessage('responseEmail'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          </div>
        </div>
      }

      <div class="radio-option">
        <input
          type="radio"
          id="response_eaddress"
          formControlName="responseDeliveryMethod"
          value="EAddress"
          [ngClass]="{ invalid: shouldRenderError('responseDeliveryMethod') }" />
        <label for="response_eaddress">{{ labels.field('responseDelivery', 'detailEAddress') }}</label>
      </div>

      @if (responseDeliveryMethod === 'EAddress') {
        <div class="conditional-card">
          <div class="field-wrapper">
            <label class="form-label" for="responseEAddress">
              {{ labels.field('responseDelivery', 'detailEAddress') }}
            </label>
            <input
              class="form-control"
              id="responseEAddress"
              formControlName="responseEAddress"
              [ngClass]="{ invalid: shouldRenderError('responseEAddress') }" />
            @if (getErrorMessage('responseEAddress'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          </div>
        </div>
      }

      <div class="radio-option">
        <input
          type="radio"
          id="response_post"
          formControlName="responseDeliveryMethod"
          value="PostalMail"
          [ngClass]="{ invalid: shouldRenderError('responseDeliveryMethod') }" />
        <label for="response_post">
          {{ 'pages.service.infoRequest.clientPayer.postalMail' | translate }}
        </label>
      </div>

      @if (responseDeliveryMethod === 'PostalMail') {
        <div class="conditional-card">
          <div class="field-wrapper">
            <label class="form-label" for="responseAddress">
              {{ labels.field('responseDelivery', 'detailAddress') }}
            </label>
            <input
              class="form-control"
              id="responseAddress"
              formControlName="responseAddress"
              [maxlength]="255"
              [ngClass]="{ invalid: shouldRenderError('responseAddress') }" />
            @if (getErrorMessage('responseAddress'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
              </div>
            }
          </div>
        </div>
      }

      <div class="radio-option">
        <input
          type="radio"
          id="response_archive"
          formControlName="responseDeliveryMethod"
          value="Archive"
          [ngClass]="{ invalid: shouldRenderError('responseDeliveryMethod') }" />
        <label for="response_archive">{{ 'pages.service.infoRequest.clientPayer.responseArchive' | translate }}</label>
      </div>

      @if (responseDeliveryMethod === 'Archive') {
        <div class="conditional-card">
          <div class="field-wrapper">
            <label class="form-label" for="responseDeliveryStructuralUnitId">
              {{ labels.field('responseDelivery', 'structuralUnit') }}
              <span class="required-field">*</span>
            </label>
            <select
              class="form-control"
              id="responseDeliveryStructuralUnitId"
              formControlName="responseDeliveryStructuralUnitId"
              [ngClass]="{ invalid: shouldRenderError('responseDeliveryStructuralUnitId') }">
              <option value="" disabled>{{ 'pages.service.infoRequest.clientPayer.selectStructuralUnit' | translate }}</option>
              @for (unit of structuralUnits; track unit.id) {
                <option [value]="unit.id">{{ unit.name }}</option>
              }
            </select>
            @if (shouldRenderError('responseDeliveryStructuralUnitId')) {
              <div class="error-wrapper">
                <small class="error-message" aria-live="polite">{{ 'components.form.errorRequired' | translate }}</small>
              </div>
            }
          </div>
        </div>
      }
    </div>

    @if (shouldRenderError('responseDeliveryMethod')) {
      <div class="error-wrapper">
        <small class="error-message" aria-live="polite">{{ 'components.form.errorRequired' | translate }}</small>
      </div>
    }
  </div>

  <!-- Section 8: Piezimes (Notes) -->
  <div class="section">
    <div class="section-header">
      <h4>{{ labels.section('notes') }}</h4>
      <app-tooltip text="infoRequestNotes" />
    </div>
    <div class="field-wrapper">
      <div class="textarea-wrapper">
        <textarea
          class="form-control notes-textarea"
          id="notes"
          formControlName="notes"
          [maxlength]="500"
          [ngClass]="{ invalid: shouldRenderError('notes') }"></textarea>
        <p class="length" [ngClass]="{ invalid: form.get('notes')?.value?.length > 500 }">
          {{ form.get('notes')?.value?.length || 0 }}/500
        </p>
      </div>
    </div>
  </div>

  <!-- Section 9: BO papildu lauki -->
  @if (!inlineEditMode) {
    <div class="section">
      <div class="card-fields">
        <div class="field-wrapper">
          <label class="form-label" for="letterNumber">
            {{ 'pages.service.infoRequest.clientPayer.letterNumber' | translate }}
          </label>
          <input
            class="form-control"
            id="letterNumber"
            formControlName="letterNumber"
            [maxlength]="50" />
        </div>
        <div class="field-wrapper">
          <div class="section-header" style="margin-bottom: 4px;">
            <label class="form-label" for="aboutSubject" style="margin-bottom: 0;">
              {{ 'pages.service.infoRequest.clientPayer.aboutSubject' | translate }}
            </label>
            <app-tooltip text="infoRequestAboutSubject" />
          </div>
          <input
            class="form-control"
            id="aboutSubject"
            formControlName="aboutSubject"
            [maxlength]="50" />
        </div>
        <div class="field-wrapper">
          <label class="form-label">
            {{ 'pages.service.infoRequest.clientPayer.submissionChannel' | translate }}
            <span class="required-field">*</span>
          </label>
          <div class="radio-group" [ngClass]="{ invalid: shouldRenderError('submissionChannel') }">
            <div class="radio-option">
              <input type="radio" id="channel_email" formControlName="submissionChannel" value="Email" />
              <label for="channel_email">E-pasts</label>
            </div>
            <div class="radio-option">
              <input type="radio" id="channel_namejs" formControlName="submissionChannel" value="Namejs" />
              <label for="channel_namejs">Namejs</label>
            </div>
            <div class="radio-option">
              <input type="radio" id="channel_post" formControlName="submissionChannel" value="PostalMail" />
              <label for="channel_post">Pa pastu</label>
            </div>
            <div class="radio-option">
              <input type="radio" id="channel_archive" formControlName="submissionChannel" value="Archive" />
              <label for="channel_archive">Arhīvs</label>
            </div>
          </div>
          @if (getErrorMessage('submissionChannel'); as errorMessage) {
            <div class="error-wrapper">
              <small class="error-message" aria-live="polite">{{ errorMessage | translate }}</small>
            </div>
          }
        </div>
        <div class="checkbox-wrapper">
          <input
            class="form-check-input lna checkbox"
            id="requiresRestrictedAccess"
            type="checkbox"
            formControlName="requiresRestrictedAccess" />
          <label class="checkbox-label" for="requiresRestrictedAccess" style="font-weight: 400;">
            {{ 'pages.service.infoRequest.clientPayer.restrictedAccess' | translate }}
          </label>
          <app-tooltip text="infoRequestRestrictedAccess" />
        </div>
      </div>
    </div>
  }
</form>

@if (!inlineEditMode) {
  <!-- Confirm Back Modal -->
  <app-confirm-modal
    [isOpen]="isOpenConfirmBack"
    (confirm)="back(true)"
    (cancel)="isOpenConfirmBack = false"
    title="unsavedChanges"
    bodyText="unsavedChangesBody"
    confirmText="continue"
    denyText="cancelBack" />

  <!-- Bottom Actions -->
  <app-service-form-actions
    [isFirstStep]="false"
    [showSaveDraft]="true"
    [isSubmitting]="isLoading"
    (exit)="back(false)"
    (saveDraft)="handleSaveDraft()"
    (deleteDraft)="onDelete()"
    (continue)="submit()" />

  <!-- Confirm Delete Modal -->
  <app-confirm-modal
    [isOpen]="isConfirmDelete"
    (confirm)="confirmDelete()"
    (cancel)="isConfirmDelete = false"
    title="deleteDraftConfirmTitle"
    bodyText="deleteDraftConfirmBody"
    confirmText="delete"
    denyText="cancel" />
}
